export default import.meta.ROLLDOWN_FILE_URL_gTxdgYqT1FnWrjfbk9DrbA